module.exports = __webpack_public_path__ + "img/summary.53a2bd90.svg";